import { render, staticRenderFns } from "./JobAlertValidation.vue?vue&type=template&id=2941d4b0&"
import script from "./JobAlertValidation.vue?vue&type=script&lang=ts&"
export * from "./JobAlertValidation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports